// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.savedBooks {
width:100%;
margin:auto;
padding:20px;
width:95%;
margin:auto;
padding-bottom:280px;
}

.savedBookInfo {
   
}

.savedBookInfo h2 {
    font-size:30px;
    font-weight: 700;
}
.savedBookImage {
    width:100%;

    text-align: center;
}
.savedBookImage img {
    width:280px;
}

.infoMessage {
    font-size:24px;
    color:white;
}

.sortButton {
    padding:9px;
    background-color:rgb(0, 157, 255);
    text-transform: uppercase;
    border-radius:4px;
    display:inline-block;
    float:left;
    margin-right:12px;
    font-weight: 600;
    padding-left:16px;
    padding-right:16px;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    box-sizing: border-box;
}

.sortButton:hover {
    background-color:rgb(0, 121, 213);
}

.sortButton:active {
    background-color:black;
    color:white;
    box-shadow:0 0 8px rgb(84, 161, 255);
}

.sortActive {
    background-color:rgb(143, 206, 245);
}
.sortTitle {
    display:inline-block;
    float:left;
    margin-right:10px;
    font-weight: 700;
    color:white;
    position: relative;
    top:-12px;
    font-size:20px;
}

.myDown {
    padding:0;
    margin:0;
    line-height:0;
    position: relative;
    top:10px;
    font-size:30px;
}
@media only screen and (min-width: 767px) { 

    .savedBooks {
        width:80%;
    }

        .savedBookImage {
            display:inline-block;
            float:left;
            width:30%;
        }
        .savedBookImage img {
            width:70%;
        }

        .savedBookInfo {
            width:70%;
            float:left;
            display:inline-block;
        }

} `, "",{"version":3,"sources":["webpack://./src/pages/saved.css"],"names":[],"mappings":";;;;AAIA;AACA,UAAU;AACV,WAAW;AACX,YAAY;AACZ,SAAS;AACT,WAAW;AACX,oBAAoB;AACpB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,UAAU;;IAEV,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;AACA;IACI,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,cAAc;AAClB;AACA;;IAEI;QACI,SAAS;IACb;;QAEI;YACI,oBAAoB;YACpB,UAAU;YACV,SAAS;QACb;QACA;YACI,SAAS;QACb;;QAEA;YACI,SAAS;YACT,UAAU;YACV,oBAAoB;QACxB;;AAER","sourcesContent":["\n\n\n\n.savedBooks {\nwidth:100%;\nmargin:auto;\npadding:20px;\nwidth:95%;\nmargin:auto;\npadding-bottom:280px;\n}\n\n.savedBookInfo {\n   \n}\n\n.savedBookInfo h2 {\n    font-size:30px;\n    font-weight: 700;\n}\n.savedBookImage {\n    width:100%;\n\n    text-align: center;\n}\n.savedBookImage img {\n    width:280px;\n}\n\n.infoMessage {\n    font-size:24px;\n    color:white;\n}\n\n.sortButton {\n    padding:9px;\n    background-color:rgb(0, 157, 255);\n    text-transform: uppercase;\n    border-radius:4px;\n    display:inline-block;\n    float:left;\n    margin-right:12px;\n    font-weight: 600;\n    padding-left:16px;\n    padding-right:16px;\n    user-select: none;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n\n.sortButton:hover {\n    background-color:rgb(0, 121, 213);\n}\n\n.sortButton:active {\n    background-color:black;\n    color:white;\n    box-shadow:0 0 8px rgb(84, 161, 255);\n}\n\n.sortActive {\n    background-color:rgb(143, 206, 245);\n}\n.sortTitle {\n    display:inline-block;\n    float:left;\n    margin-right:10px;\n    font-weight: 700;\n    color:white;\n    position: relative;\n    top:-12px;\n    font-size:20px;\n}\n\n.myDown {\n    padding:0;\n    margin:0;\n    line-height:0;\n    position: relative;\n    top:10px;\n    font-size:30px;\n}\n@media only screen and (min-width: 767px) { \n\n    .savedBooks {\n        width:80%;\n    }\n\n        .savedBookImage {\n            display:inline-block;\n            float:left;\n            width:30%;\n        }\n        .savedBookImage img {\n            width:70%;\n        }\n\n        .savedBookInfo {\n            width:70%;\n            float:left;\n            display:inline-block;\n        }\n\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
